/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const getBranchByIdIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');
export const getBranchByIdPayloadRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const GetBranchById = zod.object({
  "id": zod.union([zod.number(),zod.string().regex(getBranchByIdIdRegExpTwo)]).optional(),
  "payload": zod.union([zod.number(),zod.string().regex(getBranchByIdPayloadRegExpTwo)]).optional()
});

export type GetBranchById = zod.input<typeof GetBranchById>;
export type GetBranchByIdOutput = zod.output<typeof GetBranchById>;
